<template lang="pug">
  v-card.mt-5.full-width(width="100")
    Header(
      icon="plus",
      color="success",
      :to="{ name: 'createUser' }",
    )
      template(v-slot:filters="")
        v-col(sm=0, md=2)
          v-spacer
        v-col(sm=4)
          FilterBox.mr-2(
            :label="$t('table.user.filter')",
            :search.sync="search",
            @update:search="fetch({})",
          )
        v-col(sm=8, md=6)
          div.action-wrapper
            v-select#user-shop-filter(
              clearable,
              multiple,
              v-model="shop_id",
              item-value="id",
              item-text="name",
              :items="shops",
              :label="$t('table.user.filter_shop')",
              hide-details,
              @change="fetch({})",
            )
            v-btn.ml-1(
              fab,
              small,
              depressed,
              v-if="isSuperadmin",
              color="primary",
              @click="exportData",
            )
              v-icon fas fa-file-download
        
    TableWrapper(
      ref="table",
      type="user",
      :items="items",
      :loading="isLoading",
      :misc="misc",
      loading-text="Loading... Please wait",
      @sort="fetch",
    )
      template(v-slot:default="{ item, headers, misc }")
        RowWrapper(
          :item="item",
          :headers="headers",
          :misc="misc",
          confirmation-key="first_name",
          type="user",
          link="editUserMedia",
          @deleted="fetch({})",
        )
    Pagination.pb-2(
      :pagination="pagination",
      @changePage="fetch",
    )

</template>

<script>
import { mapGetters } from 'vuex';
import { mergeRight, propEq, pluck } from 'ramda';
import { progressWrapper, roleManager, tableHelper } from '@/config/mixins.js';
import FormWrapper from '@/components/wrapper/FormWrapper.vue';
import Header from '@/components/forms/Header.vue';

import FilterBox from '@/components/table/FilterBox.vue';
import Pagination from '@/components/table/Pagination.vue';
import RowWrapper from '@/components/wrapper/RowWrapper.vue';
import TableWrapper from '@/components/wrapper/TableWrapper.vue';

export default {
  components: {
    FilterBox,
    FormWrapper,
    Header,
    Pagination,
    RowWrapper,
    TableWrapper,
  },

  mixins: [progressWrapper, roleManager, tableHelper],

  data() {
    return {
      search: null,
      shop_id: [],
      misc: {
        sortBy: 'updatedAt',
        sortDesc: true,
      },
    };
  },

  computed: {
    ...mapGetters({
      items: 'user/items',
      shops: 'shop/items',
      pagination: 'user/pagination',
    }),
  },

  created() {
    this.$store.dispatch('shop/fetch').then(() => {
      if (this.isAdmin) {
        const shop = this.shops.find(propEq('id', this.authUser.shop_id));
        this.shop_id = pluck(
          'id',
          this.shops.filter(propEq('country', shop.country)),
        );
      } else {
        this.shop_id = [this.authUser.shop_id];
      }
    });
  },

  methods: {
    prepareFetchPayload() {
      return {
        type: 'user',
        params: {
          search: this.search,
          shop_id: this.shop_id,
          hardFetch: true,
        },
      };
    },

    exportData() {
      this.exportCSV({
        type: 'user',
        fileName: 'user.csv',
        params: mergeRight(this.$refs.table.misc, {
          search: this.search,
          shop_id: this.shop_id,
        }),
      });
    },
  },
};
</script>

<style lang="scss">
#user-shop-filter {
  .v-select__selections {
    max-height: 2em;
  }
}
</style>
